export default __webpack_public_path__ + "static/media/toiletRoll.48477d39.png";